
import { StockIn } from "@/models/base";
import Vue from "vue";
import AppRow from "./Row.vue";
import { AuthService } from "@/services";
import { MODULE } from "@/config/modules";

export default Vue.extend({
	props: {
		items: {
			type: Array as () => StockIn[],
			required: true
		},
		selectedRow: {
			type: Object as () => StockIn,
			required: true
		}
	},
	computed: {
		hasModuleTraceability():boolean {
			return AuthService.hasModule(MODULE.WERKEN_MET_TRACERING);
		},
		descriptionWidth():string {
			return this.hasModuleTraceability ? "calc(100% - 860px)" : "calc(100% - 580px)";
		},
		totalBooked():string {
			const total = this.items.reduce((sum:number, item:StockIn) => sum + item.Total, 0);
			return total.toFixed(2) + " EUR";
		},
		sortableAttributes():any {
			return{
				tag: "tbody",
				disableX: true,
				keepInY: true,
				targetClass: "handle",
				items: this.items
			};
		}
	},
	methods: {
		onEditRow(row: StockIn) {
			this.$emit("edit", row);
		},
		onRowSelect(row: StockIn) {
			this.$emit("select", row);
		},
		onRemove(row: StockIn) {
			this.$emit("remove", row);
		}
	},
	components: {
		AppRow
	},
	i18nEx: {
		componentPrefix: "components.stock"
	}
});
